import { _ as t } from "./tslib.es6-7f1b1220.js";
import { c as e, u as i, h as n, n as o } from "./lit-element-161a1699.js";
import { p as a, s as r, a as s, q as l, c as d } from "./decorators-7e9cd43b.js";
import { c as h } from "./class-map-31af68b2.js";
import { RealBaseElement as p } from "./BaseElement.esm.min.js";
import { h as u } from "./host.styles-cf05db22.js";
import { e as c } from "./event.decorator-98549cbc.js";
import { i as m } from "./if-defined-123567fc.js";
import "./types-814d68fb.js";
import { isDefined as v, stringUndefinedConverter as g, numberUndefinedConverter as b } from "./component.utils.esm.min.js";
import "./mixin.utils.esm.min.js";
import { F as f } from "./form-data-handling.mixin-3ddec2ca.js";
import "./dom.utils.esm.min.js";
import { F as y } from "./form-validation.mixin-0a6c3c34.js";
import "./error-message.component.esm.min.js";
import { punycode as _ } from "./punycode.utils.esm.min.js";
var w;
const E = e`${i(":host {\n  display: flex;\n  flex-direction: column;\n  width: calc(var(--zui-gu) * 15);\n  line-height: 0;\n  --border-bottom-color: var(--zui-color-input-bottom-line-default-enabled);\n}\n\n:host(:not([readonly])[disabled]) {\n  opacity: var(--zui-disabled-opacity);\n  pointer-events: none;\n}\n\n#input-container {\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  padding-bottom: calc(var(--zui-gu) * 0.125);\n  border-bottom: 1px solid var(--border-bottom-color);\n}\n:host(:not([readonly]):focus-within) #container:not(.invalid) #input-container {\n  padding-bottom: 0;\n  border-bottom-width: 2px;\n  border-bottom-color: var(--zui-color-input-bottom-line-default-focused);\n}\n:host(:not([readonly]):hover) #container:not(.invalid) #input-container {\n  padding-bottom: 0;\n  border-bottom-width: 2px;\n  border-bottom-color: var(--zui-color-input-bottom-line-default-hover);\n}\n:host(:not([readonly]):active) #container:not(.invalid) #input-container {\n  padding-bottom: 0;\n  border-bottom-width: 2px;\n  border-bottom-color: var(--zui-color-input-bottom-line-default-pressed);\n}\n:host(:not([readonly]):not([disabled])) #container.invalid #input-container {\n  padding-bottom: 0;\n  border-bottom-width: 2px;\n  border-bottom-color: var(--zui-color-error);\n}\n:host([readonly]) #input-container {\n  border-bottom-color: transparent;\n}\n\n#container.touch input {\n  height: calc(var(--zui-gu) * 5.75);\n  line-height: calc(var(--zui-gu) * 5.75);\n}\n\n#container.touch slot[name=interactive] {\n  margin-bottom: calc(var(--zui-gu) * 0.25);\n}\n\n#container.touch slot[name=interactive-icon]::slotted(*),\n#container.touch #unit {\n  margin-right: calc(var(--zui-gu) * 1);\n}\n\n#input-wrapper {\n  position: relative;\n  width: 100%;\n}\n#input-wrapper input {\n  background: transparent;\n  box-shadow: none;\n  box-sizing: border-box;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  outline: 0;\n  font: var(--zui-typography-body);\n  text-overflow: ellipsis;\n  color: var(--zui-color-text-default);\n  height: calc(var(--zui-gu) * 3.75);\n  line-height: calc(var(--zui-gu) * 3.75);\n}\n#input-wrapper #raw {\n  opacity: 0;\n}\n#input-wrapper #formatted {\n  opacity: 1;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n:host(:not([readonly])) #input-wrapper #formatted {\n  pointer-events: none;\n}\n:host([readonly]) #input-wrapper #raw {\n  pointer-events: none;\n}\n:host(:focus-within:not([readonly])) #input-wrapper #raw {\n  opacity: 1;\n}\n:host(:focus-within:not([readonly])) #input-wrapper #formatted {\n  opacity: 0;\n}\n\nslot[name=interactive-icon]::slotted(*) {\n  margin-left: var(--zui-space-small);\n}\n\n#unit {\n  color: var(--zui-color-text-default);\n  font: var(--zui-typography-body);\n  margin-left: var(--zui-space-small);\n}\n\n#error {\n  text-align: left;\n}\n\n:host([align-right]) #raw,\n:host([align-right]) #formatted,\n:host([align-right]) #error {\n  text-align: right;\n}\n\n/* defines color of the placeholder text */\n:host #raw::placeholder,\n:host #formatted::placeholder {\n  color: var(--zui-color-placeholder-input);\n  opacity: unset;\n}\n\n:host(:not([readonly])[disabled]) {\n  opacity: var(--zui-disabled-opacity);\n  pointer-events: none;\n}\n\n/* hides placeholder when textField is readonly or input is focused in */\n:host([readonly]) #raw::placeholder,\n:host([readonly]) #formatted::placeholder,\n:host(:focus-within) #raw::placeholder {\n  color: transparent;\n  opacity: unset;\n}\n\n/* Chrome, Safari, Edge, Opera */\n#container:not(.touch) input[type=number]::-webkit-outer-spin-button,\n#container:not(.touch) input[type=number]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\n#container:not(.touch) input[type=number] {\n  -moz-appearance: textfield;\n}\n\n#container:not(.touch) #arrow-container {\n  margin-left: calc(var(--zui-gu) * 1);\n}\n\n:host(:not([readonly])[disabled]) zui-interactive-icon {\n  opacity: unset;\n}\n\n:host(:not([readonly])) {\n  -webkit-user-select: none;\n  /* Chrome all / Safari all */\n  -moz-user-select: none;\n  /* Firefox all */\n  -ms-user-select: none;\n  /* IE 10+ */\n  user-select: none;\n  /* Likely future */\n}")}`;
let x = w = class extends y(f(p, {
  disableSubmitOnEnter: !0
})) {
  constructor() {
    super(), this.required = !1, this.inputType = "text", this.step = 1, this.unit = "", this.alignRight = !1, this.placeholder = "", this._hasBeenBlurred = !1, this._isArrowAsLastClicked = !1, this._handleOutsideClick = t => {
      !(this.isSameNode(t.target) && t.composedPath().some(t => t instanceof w)) && this._isArrowAsLastClicked && (this._isArrowAsLastClicked = !1, this.emitBlurEvent());
    }, this.addValidator({
      type: "valueMissing",
      validator: () => !1 === this.required || !0 !== this._inputElement.validity.valueMissing,
      validatesOnProperties: ["required"]
    }), this.addValidator({
      type: "tooShort",
      validator: () => !(this.value && this.minlength && this._isTextInput) || this.value.length >= this.minlength,
      validatesOnProperties: ["minlength"]
    }), this.addValidator({
      type: "tooLong",
      validator: () => !(this.value && this.maxlength && this._isTextInput) || this.value.length <= this.maxlength,
      validatesOnProperties: ["maxlength"]
    }), this.addValidator({
      type: "rangeUnderflow",
      validator: () => !this.min || !this.value || "number" !== this.inputType || parseFloat(this.value) >= this.min,
      validatesOnProperties: ["min"]
    }), this.addValidator({
      type: "rangeOverflow",
      validator: () => !this.max || !this.value || "number" !== this.inputType || parseFloat(this.value) <= this.max,
      validatesOnProperties: ["max"]
    }), this.addValidator({
      type: "patternMismatch",
      validator: () => void 0 === this.pattern || !0 !== this._inputElement.validity.patternMismatch,
      validatesOnProperties: ["pattern"]
    }), this.setDefaultValidityMessages({
      valueMissing: w.REQUIRED_ERROR_MESSAGE
    }), this.setDefaultValidityMessages({
      tooShort: w.TOO_SHORT_ERROR_MESSAGE
    }), this.setDefaultValidityMessages({
      tooLong: w.TOO_LONG_ERROR_MESSAGE
    }), this.setDefaultValidityMessages({
      rangeUnderflow: w.TOO_SMALL_ERROR_MESSAGE
    }), this.setDefaultValidityMessages({
      rangeOverflow: w.TOO_LARGE_ERROR_MESSAGE
    }), this.setDefaultValidityMessages({
      patternMismatch: w.PATTERN_ERROR_MESSAGE
    });
  }
  emitInputEvent() {
    this.dispatchEvent(new InputEvent("input", {
      bubbles: !0,
      cancelable: !1,
      composed: !1
    }));
  }
  emitChangeEvent() {
    this.dispatchEvent(new InputEvent("change", {
      bubbles: !0,
      cancelable: !1,
      composed: !1
    }));
  }
  emitBlurEvent() {
    this.dispatchEvent(new FocusEvent("blur", {
      bubbles: !0,
      cancelable: !1,
      composed: !1
    }));
  }
  get _isTextInput() {
    return "text" === this.inputType || "email" === this.inputType;
  }
  get _formattedValue() {
    return "function" == typeof this.formattingCallback ? v(this.value) ? this.formattingCallback(_.toUnicode(this.value)) : void 0 : v(this.value) ? _.toUnicode(this.value) : void 0;
  }
  get validationState() {
    return console.warn("The usage of validationState is deprecated and will be removed, use validity instead."), Object.assign(Object.assign({}, this.getValidityMessages().customError ? {
      message: this.getValidityMessages().customError
    } : {}), this.validationCallback(this.value));
  }
  static get styles() {
    return [u, E];
  }
  connectedCallback() {
    super.connectedCallback(), window.addEventListener("click", this._handleOutsideClick);
  }
  disconnectedCallback() {
    window.removeEventListener("click", this._handleOutsideClick), super.disconnectedCallback();
  }
  stepUp() {
    this._inputElement.stepUp(), this._alignValue(), this._handleInput(), this.emitInputEvent(), this._isArrowAsLastClicked = !0;
  }
  stepDown() {
    this._inputElement.stepDown(), this._alignValue(), this._handleInput(), this.emitInputEvent(), this._isArrowAsLastClicked = !0;
  }
  _propagateIconSlotProps() {
    this._assignedInteractiveIcons.forEach(t => {
      var e;
      null === (e = t.querySelector("[zuiIcon]")) || void 0 === e || e.setAttribute("size", "m"), t.disabled = this.disabled || this.readonly, t.smallHitArea = !0;
    });
  }
  _handleIconSlotChange() {
    this._propagateIconSlotProps();
  }
  _clampingNumberValue() {
    "number" == typeof this.max && Number.parseFloat(this._inputElement.value) > this.max && (this._inputElement.value = this.max.toString()), "number" == typeof this.min && Number.parseFloat(this._inputElement.value) < this.min && (this._inputElement.value = this.min.toString());
  }
  _alignValue() {
    this._clampingNumberValue();
  }
  _handleInput() {
    "number" === this.inputType && isNaN(this._inputElement.valueAsNumber) ? this.value = "" : (this.value = this._inputElement.value, this._hasBeenBlurred = !1);
  }
  _handleBlur() {
    this._alignValue(), this._hasBeenBlurred = !0;
  }
  _handleChange() {
    this.emitChangeEvent();
  }
  get _showValidationWarning() {
    return this.willValidate && this.invalid && this._hasBeenBlurred;
  }
  get _isUpArrowDisabled() {
    return this.readonly || this.disabled || Number.parseFloat(this.value) >= this.max;
  }
  get _isDownArrowDisabled() {
    return this.readonly || this.disabled || Number.parseFloat(this.value) <= this.min;
  }
  render() {
    return n`<div id="container" class="${h({
      touch: this.hasTouch,
      invalid: this._showValidationWarning
    })}"><div id="input-container"><div id="input-wrapper"><input id="raw" zuiFormControl min="${m(this.min)}" max="${m(this.max)}" step="${this.step}" type="${this.inputType}" ?readonly="${this.readonly}" ?disabled="${this.disabled}" placeholder="${this.placeholder}" .value="${m(this.value)}" @blur="${this._handleBlur}" @input="${this._handleInput}" @change="${this._handleChange}" ?required="${this.required}" minlength="${m(this.minlength)}" maxlength="${m(this.maxlength)}" pattern="${m(this.pattern)}"> <input id="formatted" tabindex="-1" type="text" ?readonly="${this.readonly}" ?disabled="${this.disabled}" placeholder="${this.placeholder}" .value="${m(this._formattedValue)}"></div>${this.unit ? n`<span id="unit">${this.unit}</span>` : o}<slot id="iconslot" name="interactive-icon" @slotchange="${this._handleIconSlotChange}"></slot>${"number" !== this.inputType || this.hasTouch ? o : n`<div id="arrow-container"><zui-interactive-icon ?disabled="${this._isUpArrowDisabled}" emphasis="default" tabindex="-1" small-hit-area @click="${this.stepUp}"><zui-icon-arrow-filled-arrow-filled-up size="xs"></zui-icon-arrow-filled-arrow-filled-up></zui-interactive-icon><zui-interactive-icon ?disabled="${this._isDownArrowDisabled}" emphasis="default" tabindex="-1" small-hit-area @click="${this.stepDown}"><zui-icon-arrow-filled-arrow-filled-down size="xs"></zui-icon-arrow-filled-arrow-filled-down></zui-interactive-icon></div>`}</div>${this._showValidationWarning ? n`<zui-error-message id="error">${this.validationMessage}</zui-error-message>` : o}</div>`;
  }
};
x.REQUIRED_ERROR_MESSAGE = "This field is required.", x.TOO_SMALL_ERROR_MESSAGE = "The number is too small.", x.TOO_LARGE_ERROR_MESSAGE = "The number is too large.", x.TOO_SHORT_ERROR_MESSAGE = "The input is too short.", x.TOO_LONG_ERROR_MESSAGE = "The input is too long.", x.PATTERN_ERROR_MESSAGE = "The input does not match the required pattern.", t([a({
  reflect: !0,
  converter: g
})], x.prototype, "pattern", void 0), t([a({
  reflect: !0,
  type: Boolean
})], x.prototype, "required", void 0), t([a({
  reflect: !0,
  converter: b
})], x.prototype, "minlength", void 0), t([a({
  reflect: !0,
  converter: b
})], x.prototype, "maxlength", void 0), t([a({
  reflect: !1,
  attribute: "input-type"
})], x.prototype, "inputType", void 0), t([a({
  reflect: !0,
  converter: b
})], x.prototype, "min", void 0), t([a({
  reflect: !0,
  converter: b
})], x.prototype, "max", void 0), t([a({
  reflect: !0,
  type: Number
})], x.prototype, "step", void 0), t([a({
  reflect: !0,
  type: String
})], x.prototype, "unit", void 0), t([a({
  type: Boolean,
  reflect: !0,
  attribute: "align-right"
})], x.prototype, "alignRight", void 0), t([a({
  type: String,
  reflect: !0
})], x.prototype, "placeholder", void 0), t([a({
  reflect: !0,
  converter: g
})], x.prototype, "value", void 0), t([a({
  reflect: !1,
  attribute: !1
})], x.prototype, "formattingCallback", void 0), t([c()], x.prototype, "emitInputEvent", null), t([c()], x.prototype, "emitChangeEvent", null), t([c()], x.prototype, "emitBlurEvent", null), t([r()], x.prototype, "_hasBeenBlurred", void 0), t([s("#raw")], x.prototype, "_inputElement", void 0), t([l("interactive-icon", !0, "zui-interactive-icon")], x.prototype, "_assignedInteractiveIcons", void 0), x = w = t([d("zui-textfield")], x);
export { x as TextField };
